// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  background: url("https://mediabeat.co.za/wp-content/uploads/2020/08/250x250_logo-150x150.png");
  background-size: 130px;
  width: 130px;
  height: 131px;
  margin: 20px 0;
  display: inline-block;
}

.notification {
  text-align: center;
  margin: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
}
.header .title {
  display: flex;
}
.header .title .name-wrapper {
  display: inline-block;
  align-self: center;
  margin-left: 20px;
}
.header .title .name-wrapper .name {
  color: var(--blue);
}
.header button {
  display: inline-block;
  color: var(--blue);
}
.header button.active, .header button:hover {
  color: var(--gray);
}

.banner {
  position: relative;
  overflow: hidden;
}
.banner video {
  position: absolute;
  width: 100%;
  pointer-events: none;
}
.banner .bg {
  height: 500px;
  background-size: cover !important;
  background-repeat: no-repeat !important;
}
.banner .bg-our-story {
  background: url("https://mediabeat.co.za/wp-content/uploads/2020/08/shutterstock_1739064734-scaled.jpg");
  background-position: 0 50%;
}
.banner .bg-service {
  background: url("https://mediabeat.co.za/wp-content/uploads/2020/08/shutterstock_725949823-scaled.jpg");
  background-position: 0 50%;
}
.banner .bg-clients {
  background: url("https://mediabeat.co.za/wp-content/uploads/2020/08/shutterstock_725949823-scaled.jpg");
  background-position: 0 50%;
}
.banner .bg-articles {
  background: url("https://mediabeat.co.za/wp-content/uploads/2020/08/articles.png");
  background-position: 50%;
}
.banner .bg-contact-us {
  background: url("https://mediabeat.co.za/wp-content/uploads/2020/08/1432300205-huge-scaled.jpg");
}

.page-content .content {
  line-height: 20px;
}

hr {
  border: 1px solid var(--gray);
  margin: 0;
  padding: 0;
}

.animate.step-1 {
  position: absolute;
  left: 0;
  animation-duration: 4s;
  animation-name: animate-slide-1;
}
.animate.step-2 {
  position: absolute;
  left: 72px;
  animation-duration: 3s;
  animation-name: animate-slide-2;
}
.animate.step-3 {
  position: absolute;
  left: 118px;
  animation-duration: 3s;
  animation-name: animate-slide-3;
}
.animate.step-4 {
  position: absolute;
  left: 180px;
  animation-duration: 3s;
  animation-name: animate-slide-4;
}

@keyframes animate-slide-1 {
  0% {
    left: 100%;
  }
  10% {
    left: 0;
  }
}
@keyframes animate-slide-2 {
  0% {
    left: 100%;
  }
  25% {
    left: 100%;
  }
  45% {
    left: 72px;
  }
}
@keyframes animate-slide-3 {
  0% {
    left: 100%;
  }
  50% {
    left: 100%;
  }
  65% {
    left: 118px;
  }
}
@keyframes animate-slide-4 {
  0% {
    left: 100%;
  }
  75% {
    left: 100%;
  }
  85% {
    left: 180px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/layout-template.scss"],"names":[],"mappings":"AACA;EACE,8FAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;AAAF;AAEE;EACE,aAAA;AAAJ;AAEI;EACE,qBAAA;EACA,kBAAA;EACA,iBAAA;AAAN;AAEM;EACE,kBAAA;AAAR;AAKE;EACE,qBAAA;EACA,kBAAA;AAHJ;AAKI;EACE,kBAAA;AAHN;;AAQA;EACE,kBAAA;EACA,gBAAA;AALF;AAOE;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;AALJ;AAQE;EACE,aAAA;EACA,iCAAA;EACA,uCAAA;AANJ;AASE;EACE,wGAAA;EACA,0BAAA;AAPJ;AAUE;EACE,uGAAA;EACA,0BAAA;AARJ;AAWE;EACE,uGAAA;EACA,0BAAA;AATJ;AAYE;EACE,kFAAA;EACA,wBAAA;AAVJ;AAaE;EACE,gGAAA;AAXJ;;AAgBE;EACE,iBAAA;AAbJ;;AAiBA;EACE,6BAAA;EACA,SAAA;EACA,UAAA;AAdF;;AAoBE;EACE,kBAAA;EACA,OAAA;EACA,sBAAA;EACA,+BAAA;AAjBJ;AAoBE;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,+BAAA;AAlBJ;AAqBE;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,+BAAA;AAnBJ;AAsBE;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,+BAAA;AApBJ;;AA8BA;EACE;IAAK,UAAA;EA1BL;EA2BA;IAAM,OAAA;EAxBN;AACF;AA0BA;EACE;IAAK,UAAA;EAvBL;EAwBA;IAAM,UAAA;EArBN;EAsBA;IAAM,UAAA;EAnBN;AACF;AAqBA;EACE;IAAK,UAAA;EAlBL;EAmBA;IAAM,UAAA;EAhBN;EAiBA;IAAM,WAAA;EAdN;AACF;AAgBA;EACE;IAAK,UAAA;EAbL;EAcA;IAAM,UAAA;EAXN;EAYA;IAAM,WAAA;EATN;AACF","sourcesContent":["\r\n.logo {\r\n  background: url('https://mediabeat.co.za/wp-content/uploads/2020/08/250x250_logo-150x150.png');\r\n  background-size: 130px;\r\n  width: 130px;\r\n  height: 131px;\r\n  margin: 20px 0;\r\n  display: inline-block;\r\n}\r\n\r\n.notification {\r\n  text-align: center;\r\n  margin: 20px;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n\r\n  .title {\r\n    display: flex;\r\n  \r\n    .name-wrapper {\r\n      display: inline-block;\r\n      align-self: center;\r\n      margin-left: 20px;\r\n  \r\n      .name {\r\n        color: var(--blue);\r\n      }\r\n    }\r\n  }\r\n  \r\n  button {\r\n    display: inline-block;\r\n    color: var(--blue);\r\n\r\n    &.active, &:hover {\r\n      color: var(--gray);\r\n    }\r\n  }\r\n}\r\n\r\n.banner {\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  video {\r\n    position: absolute;\r\n    width: 100%;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .bg {\r\n    height: 500px;\r\n    background-size: cover!important;\r\n    background-repeat: no-repeat!important;\r\n  }\r\n\r\n  .bg-our-story {\r\n    background: url('https://mediabeat.co.za/wp-content/uploads/2020/08/shutterstock_1739064734-scaled.jpg');\r\n    background-position: 0 50%;\r\n  }\r\n\r\n  .bg-service {\r\n    background: url('https://mediabeat.co.za/wp-content/uploads/2020/08/shutterstock_725949823-scaled.jpg');\r\n    background-position: 0 50%;\r\n  }\r\n\r\n  .bg-clients {\r\n    background: url('https://mediabeat.co.za/wp-content/uploads/2020/08/shutterstock_725949823-scaled.jpg');\r\n    background-position: 0 50%;\r\n  }\r\n\r\n  .bg-articles {\r\n    background: url('https://mediabeat.co.za/wp-content/uploads/2020/08/articles.png');\r\n    background-position: 50%;\r\n  }\r\n\r\n  .bg-contact-us {\r\n    background: url('https://mediabeat.co.za/wp-content/uploads/2020/08/1432300205-huge-scaled.jpg');\r\n  }\r\n}\r\n.page-content {\r\n\r\n  .content {\r\n    line-height: 20px;\r\n  }\r\n}\r\n\r\nhr {\r\n  border: 1px solid var(--gray);\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.animate {\r\n  // animation-fill-mode: backwards;\r\n\r\n  &.step-1 {\r\n    position: absolute;\r\n    left: 0;\r\n    animation-duration: 4s;\r\n    animation-name: animate-slide-1;\r\n  }\r\n\r\n  &.step-2 {\r\n    position: absolute;\r\n    left: 72px;\r\n    animation-duration: 3s;\r\n    animation-name: animate-slide-2;\r\n  }\r\n\r\n  &.step-3 {\r\n    position: absolute;\r\n    left: 118px;\r\n    animation-duration: 3s;\r\n    animation-name: animate-slide-3;\r\n  }\r\n\r\n  &.step-4 {\r\n    position: absolute;\r\n    left: 180px;\r\n    animation-duration: 3s;\r\n    animation-name: animate-slide-4;\r\n  }\r\n\r\n}\r\n// 5 seconds\r\n// 1 - 0.5 -> 1.5\r\n// 2 - 2   -> 3\r\n// 3 - 3.5 -> 4.5\r\n// 4 - 5   -> 6\r\n\r\n@keyframes animate-slide-1 {\r\n  0% { left: 100%; }\r\n  10% { left: 0; }\r\n}\r\n\r\n@keyframes animate-slide-2 {\r\n  0% { left: 100%; }\r\n  25% { left: 100%; }\r\n  45% { left: 72px; }\r\n}\r\n\r\n@keyframes animate-slide-3 {\r\n  0% { left: 100%; }\r\n  50% { left: 100%; }\r\n  65% { left: 118px; }\r\n}\r\n\r\n@keyframes animate-slide-4 {\r\n  0% { left: 100%; }\r\n  75% { left: 100%; }\r\n  85% { left: 180px; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
